/***
 * GRYND — Restore Header Scroll Behavior
 * Shows header when user scrolls up, hides when scrolling down.
 */

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header-wrapper");
  if (!header) return;

  let lastScroll = window.scrollY;
  let isVisible = true;
  const delta = 5; // Sensitivity overlap
  const offset = 400; // Keep header visible for first 400px (Hero section buffer)

  function showHeader() {
    header.style.transform = "translateY(0)";
    header.style.opacity = "1";
    header.classList.add("header--visible");
    isVisible = true;
  }

  function hideHeader() {
    header.style.transform = "translateY(-100%)";
    header.style.opacity = "0";
    header.classList.remove("header--visible");
    isVisible = false;
  }

  // Initialize
  showHeader();

  window.addEventListener("scroll", () => {
    const current = window.scrollY;

    // Prevent negative scroll bounce on mobile
    if (Math.abs(lastScroll - current) <= delta) return;

    // Always show if at the top (buffer zone)
    if (current < offset) {
      if (!isVisible) showHeader();
    }
    // Scrolling Down -> Hide
    else if (current > lastScroll && current > offset) {
      if (isVisible) hideHeader();
    }
    // Scrolling Up -> Show
    else if (current < lastScroll) {
      if (!isVisible) showHeader();
    }

    lastScroll = current;
  });
});

/* ... keep the rest of your custom.js below this line ... */


/* document.addEventListener("DOMContentLoaded", function () {
  const intro = document.getElementById("site-intro");
  const headline = document.querySelector(".intro-headline");

  if (!intro || !headline) return;

  // Check if the intro has already been shown during this session
  const hasSeenIntro = sessionStorage.getItem("grynd_intro_seen");

  if (hasSeenIntro) {
    // If already seen, hide the intro immediately and allow scroll
    intro.style.display = "none";
    document.body.classList.remove("no-scroll");
    return;
  }

  // First time in session: show intro and block scroll
  document.body.classList.add("no-scroll");

  // Fallback in case animationend doesn't fire
  const fallback = setTimeout(() => {
    fadeOutAndScroll();
  }, 2500); // fallback duration: animation duration + delay

  // Trigger exit logic when the animation ends
  headline.addEventListener("animationend", function () {
    clearTimeout(fallback);
    fadeOutAndScroll();
  });

  function fadeOutAndScroll() {
    // Start fade-out transition
    intro.classList.add("fade-out");

    // After transition ends, remove intro and restore scroll
    setTimeout(() => {
      intro.style.display = "none";
      document.body.classList.remove("no-scroll");
      window.scrollTo({ top: 1, behavior: "smooth" });
    }, 230); // matches CSS fade-out transition

    // Store flag in sessionStorage so it doesn't repeat
    sessionStorage.setItem("grynd_intro_seen", "true");
  }
}); */


/**
 * Makes the top announcement bar sticky only on product pages.
 * Also calculates height to offset the main header so they don't overlap.
 */
document.addEventListener("DOMContentLoaded", () => {
  const announcementBar = document.querySelector('.announcement-bar-section');
  const headerWrapper = document.querySelector('.header-wrapper');

  if (!announcementBar) return;

  const updateHeaderOffset = () => {
    const isProductPage = window.location.pathname.includes('/products/');
    
    if (isProductPage) {
      announcementBar.classList.add('announcement-bar--sticky');
      const barHeight = announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${barHeight}px`);
    } else {
      announcementBar.classList.remove('announcement-bar--sticky');
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }
  };

  // Run on load
  updateHeaderOffset();

  // Re-calculate if window resizes (e.g. text wraps on mobile)
  window.addEventListener('resize', updateHeaderOffset);
});

/**
 * GRYND — Multi-Funnel Cart Upsell Message (v3)
 *
 * BUG FIXES vs v2:
 * 1. DOUBLE-COUNT FIX: The cart drawer <cart-drawer> is always present in the
 *    DOM. On the /cart page this caused document.querySelectorAll('.cart-item')
 *    to count items from BOTH the drawer AND the page, doubling sockCount.
 *    Fix: scope the item query to the correct container per context.
 *
 * 2. AJAX SYNC FIX: The /cart page uses <cart-items> custom element which
 *    re-renders via the Section Rendering API. The MutationObserver 500ms
 *    timeout is unreliable against this. Fix: monkey-patch fetch() globally
 *    so we fire 350ms after any /cart API response resolves.
 */

// --- Debounce helper to prevent multiple rapid-fire calls ---
let _gryndUpsellTimer = null;
function _debouncedUpsell(delay) {
  clearTimeout(_gryndUpsellTimer);
  _gryndUpsellTimer = setTimeout(updateCartFreeShipping, delay || 350);
}

function updateCartFreeShipping() {
  // --- Step 1: Scope item rows to the correct live container ---
  // On /cart page: read from <cart-items> (#main-cart-items) only.
  // In cart drawer: read from #CartDrawer only.
  // This prevents the always-present drawer from doubling counts on the page.
  let itemScope;
  if (window.location.pathname.includes('/cart')) {
    // /cart page — use the page's native container; drawer may also be present
    // but its .cart-item rows live inside cart-drawer which is NOT inside cart-items
    itemScope = document.querySelector('cart-items') || document.body;
  } else {
    // All other pages (PDP, home, etc.) — drawer is the only live cart UI
    itemScope = document.querySelector('cart-drawer') || document.body;
  }

  let sockCount    = 0;
  let sunniesCount = 0;

  itemScope.querySelectorAll('.cart-item').forEach(row => {
    // Use cart-item__name anchor (present in both templates) for product handle
    const link     = row.querySelector('a.cart-item__name');
    // Grab the number input — same class in both drawer and cart page
    const qtyInput = row.querySelector('input.quantity__input');
    if (!link || !qtyInput) return;

    const href   = (link.getAttribute('href') || '').toLowerCase();
    // Read the *current* numeric value from the input (post-AJAX re-render)
    const qty    = parseInt(qtyInput.value, 10) || 0;
    if (qty <= 0) return;

    const isSock = href.includes('sock') || href.includes('endurance');
    if (isSock) {
      sockCount    += qty;
    } else {
      sunniesCount += qty;
    }
  });

  // --- Step 2: Inject / update the upsell message above checkout button(s) ---
  // Selector covers: drawer, /cart page submit button, cart block button
  const checkoutBtns = document.querySelectorAll(
    '#CartDrawer-Checkout, button[name="checkout"], .cart__blocks .button'
  );

  checkoutBtns.forEach(btn => {
    const parent = btn.parentElement;
    let msg = parent.querySelector('.grynd-free-shipping-msg');

    // Empty cart — remove message entirely
    if (sockCount === 0 && sunniesCount === 0) {
      if (msg) msg.remove();
      return;
    }

    // Create message element if it doesn't exist yet
    if (!msg) {
      msg = document.createElement('div');
      msg.className = 'grynd-free-shipping-msg';
      msg.style.display = 'flex';
      msg.style.alignItems = 'center';
      msg.style.justifyContent = 'center';
      msg.style.padding = '12px 16px'; // Increased padding for breathing room
      msg.style.marginBottom = '15px';
      msg.style.textAlign = 'center';
      msg.style.fontWeight = 'bold';
      msg.style.fontSize = '12px'; // Slightly scaled down to fit better
      msg.style.lineHeight = '1.4'; // Better readability if it wraps
      msg.style.borderRadius = '6px'; // Slightly softer pill look
      msg.style.color = '#ffffff';
      msg.style.width = '100%'; // Ensure it respects parent boundaries
      msg.style.boxSizing = 'border-box'; // Keep padding internal
      msg.style.wordBreak = 'break-word'; // Prevent text bleed
      parent.insertBefore(msg, btn);
    }

    let innerText = '';
    let status    = 'locked'; // 'locked' = orange, 'unlocked' = green

    // SOCKS ONLY
    if (sockCount > 0 && sunniesCount === 0) {
      if (sockCount === 1) {
        innerText = '🚨 Add 2 pairs to unlock <span style="white-space: nowrap; color:#FF6B00;">$59.99 Runner Pack!</span>';
        status    = 'locked';
      } else if (sockCount === 2) {
        innerText = '🚨 Add 1 pair to unlock <span style="white-space: nowrap; color:#FF6B00;">$59.99 Runner Pack!</span>';
        status    = 'locked';
      } else if (sockCount === 3) {
        innerText = '🔥 <span style="white-space: nowrap; color:#4ade80;">$59.99 Runner Pack UNLOCKED!</span><br><span style="font-size: 11px; font-weight: normal; margin-top: 2px; display: inline-block;">(Add 2 more for FREE Shipping)</span>';
        status    = 'unlocked';
      } else if (sockCount === 4) {
        innerText = '🚨 Add 1 pair to unlock<br><span style="white-space: nowrap; color:#FF6B00;">$89.99 Pack + FREE Shipping!</span>';
        status    = 'locked';
      } else if (sockCount >= 5) {
        innerText = '🔥 <span style="white-space: nowrap; color:#4ade80;">5-Pair Rotation Pack + FREE Shipping</span><br><span style="color:#4ade80;">UNLOCKED!</span>';
        status    = 'unlocked';
      }
    }
    // SUNNIES ONLY
    else if (sunniesCount > 0 && sockCount === 0) {
      if (sunniesCount === 1) {
        innerText = '🚨 Add 1 pair to unlock<br><span style="white-space: nowrap; color:#FF6B00;">$114.99 Bundle + FREE Shipping!</span>';
        status    = 'locked';
      } else if (sunniesCount >= 2) {
        innerText = '🔥 <span style="white-space: nowrap; color:#4ade80;">$114.99 Bundle + FREE Shipping</span><br><span style="color:#4ade80;">UNLOCKED!</span>';
        status    = 'unlocked';
      }
    }
    // MIXED CART
    else if (sockCount > 0 && sunniesCount > 0) {
      innerText = '🔥 <span style="color:#4ade80;">Premium GRYND tier pricing unlocked!</span>';
      status    = 'unlocked';
    }
    // FALLBACK
    else {
      msg.style.display = 'none';
      return;
    }

    msg.style.display = 'block';
    msg.innerHTML     = innerText;

    if (status === 'locked') {
      msg.style.backgroundColor = 'rgba(255, 107, 0, 0.1)';
      msg.style.border          = '1px solid #FF6B00';
    } else {
      msg.style.backgroundColor = 'rgba(74, 222, 128, 0.1)';
      msg.style.border          = '1px solid #4ade80';
    }
  });
}

// --- Run on initial load ---
document.addEventListener('DOMContentLoaded', updateCartFreeShipping);

// --- Monkey-patch fetch() to catch /cart page Section Rendering API updates ---
// The <cart-items> custom element uses fetch() internally; we hook into the
// response to fire our upsell update 350ms after any cart-related API call.
(function () {
  const _nativeFetch = window.fetch;
  window.fetch = function (...args) {
    const result = _nativeFetch.apply(this, args);
    const url = (typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url)) || '';
    // Only intercept cart-related requests
    if (url.includes('/cart') || url.includes('sections=')) {
      result.then(() => _debouncedUpsell(350));
    }
    return result;
  };
})();

// --- MutationObserver: catches drawer open/close and other DOM changes ---
// Debounced at 500ms to give Section Rendering enough time to complete.
document.addEventListener('DOMContentLoaded', () => {
  const cartObserver = new MutationObserver(() => _debouncedUpsell(500));
  cartObserver.observe(document.body, { childList: true, subtree: true });
});